import "./css/Buttons.css";
import Icono from "../Icono";

/* La baldosa de acceso.
 *
 * QUÉ CAMBIÓ Y POR QUÉ. Antes el icono entraba como `background-image` con un
 * PNG heredado de CantApp, y el botón se medía así:
 *
 *     max-width: 22vh; min-width: 22vh;
 *
 * Un ANCHO medido en alto de ventana. En un teléfono alto eso da ~190px fijos,
 * así que el texto no entraba, se partía en dos renglones y quedaba pegado al
 * bloque naranja del `+` — que es exactamente como se veía. Y el mismo botón en
 * una pantalla apaisada quedaba diminuto, porque la ventana es más baja.
 *
 * Ahora el ancho lo pone la grilla que lo contiene y el alto es de contenido,
 * con un mínimo. El icono es un SVG en línea que hereda el color del texto, así
 * que anda en tema claro y oscuro sin una segunda copia del archivo.
 *
 * EL `+` DEJÓ DE SER UN BLOQUE NARANJA PEGADO AL BORDE. Ese bloque le comía
 * ancho al texto justo en la pantalla donde menos sobra, y gritaba más fuerte
 * que la acción. Ahora es un signo discreto a la derecha: sigue diciendo "esto
 * agrega algo", que es lo único que tenía que decir.
 *
 * `icono` es el NOMBRE del dibujo (ver `Icono.jsx`), no una ruta a un archivo.
 */
const Button = ({
  text = "",
  type = "button",
  icono = null,
  plus = false,
  onClick,
}) => (
  <button className="btn-std-body" onClick={onClick} type={type}>
    {icono && <Icono nombre={icono} tam={22} className="btn-std-icono" />}
    <span className="btn-std-text">{text}</span>
    {plus && (
      <Icono nombre="mas" tam={16} className="btn-std-mas" titulo="Agregar" />
    )}
  </button>
);

export default Button;
